
    var riot = require('riot')
    //src: starling/src/tags/modal-intro.html
riot.tag2('modal-intro',
  '<div class="modal-container {this.showing ? \'\' : \'hidden\'}"> <div class="modal-background" ref="modalBackground" onclick="{hide}"></div> <div ref="videoModal" class="video-modal"> <header> <h4>Welcome to Plectica!</h4> <h1>Here\'s a quick video tour...</h1> <button class="dismiss" onclick="{hide}">close</button> <button class="start-mapping button-primary" onclick="{hide}">Start mapping &rarr;</button> </header> <video id="intro-video" ref="video" controls controlslist="nodownload" onended="{morphDismissButton}"> <source riot-src="https://s3.amazonaws.com/plectica-app-assets/intro-video.mp4?v={this.canvas.config.app_version}" type="video/mp4"> </video> </div> </div>',
  '',
  'ref="main"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants.js');

this.canvas = opts.canvas;
this.canvas.introModalTag = this;
this.showing = false;

this.hide = function () {
  if (_this.canvas.sidebarStatus !== 'user-guide') {
    _this.canvas.openSidebar('user-guide');
    _this.canvas.userGuideTag.tags['user-guide-item'][0].show();
  }

  var newVideoPosEl = document.querySelector('.user-guide-item--video');

  if (newVideoPosEl) {
    var newVideoPos = newVideoPosEl.getBoundingClientRect();
    _this.refs.videoModal.style.left = newVideoPos.left + 'px';
    _this.refs.videoModal.style.top = newVideoPos.top + 'px';
  }

  _this.refs.videoModal.style.transformOrigin = 'top left';
  _this.refs.videoModal.style.transform = 'translate(0,0) scale(0.25)';
  _this.refs.modalBackground.style.backgroundColor = 'transparent';

  if (window.user) {
    window.user.closed_intro = true;
  }

  if (_this.refs.video) {
    _this.refs.video.pause();
  }

  $('.video-modal').on('transitionend', function () {
    $('.modal-container').addClass('hidden');

    _this.refs.videoModal.style.left = '50%';
    _this.refs.videoModal.style.top = '10vh';
    _this.refs.modalBackground.style.backgroundColor = 'rgba(0,0,0,0.3)';
    _this.refs.videoModal.style.transform = 'translate(-50%, 0) scale(1)';

    _this.showing = false;
    $('.video-modal').off('transitionend');
  });

  _this.showing = false;
};

this.show = function () {
  $('.modal-container').removeClass('hidden');
  if (_this.refs.video) {
    _this.refs.video.currentTime = 0;
    _this.refs.video.play();
  }
  _this.showing = true;
};

this.on('mount', function () {
  document.addEventListener('keyup', function (e) {
    var ESCAPE = _constants.KEY_CODES.ESCAPE;

    if (e.keyCode == ESCAPE && _this.showing) {
      _this.hide();
    }
  });
});
this.morphDismissButton = function () {
  _this.refs.main.classList.add('done-playing');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-intro')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-intro.html
// module id = 631
// module chunks = 0